export { default } from './WeatherCell';
